import axios from "axios";
import InputField from "components/InputField/InputField";
import React, { Component } from "react";
import { Link } from "react-router";
import { toast } from "react-toastify";
import { API_GROUP_INVITES } from "../../constants/api";

const createInvites = ({ id, data }) =>
  axios.post(API_GROUP_INVITES, {
    group_invites: {
      group_id: id,
      emails: data,
    },
  });

export default class StudyGroupSuperhostInviteMembers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };
  }

  handleSendInvitations = async () => {
    try {
      const { data } = this.state;
      const {
        params: { id },
        router,
      } = this.props;

      await createInvites({
        id,
        data: Object.values(data).filter(Boolean),
      });

      toast.success("The invitation has been sent");
      router.push(`/groups/${id}/members`);
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { id } = this.props.params;

    return (
      <div style={{ maxWidth: 700, margin: "auto", marginBottom: "20px" }}>
        <div style={{ margin: "0 20px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginBottom: "16px",
              columnGap: "32px",
            }}
          >
            {Array.from({ length: 10 }).map((_, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  gap: "16px",
                  alignItems: "center",
                  flex: "1 1 auto",
                }}
              >
                <div>Email:</div>
                <InputField
                  value={this.state.data[idx] || ""}
                  onChange={(e) => {
                    const { value } = e.target;

                    this.setState((prev) => ({
                      data: { ...prev.data, [idx]: value },
                    }));
                  }}
                  className="w-full"
                />
              </div>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Link to={`/groups/${id}/members`}>
              <button className="button_link">
                <div>Return To All Invitations</div>
                <div>(Clear Information)</div>
              </button>
            </Link>
            <button
              style={{ fontSize: 24 }}
              className="button_link"
              onClick={this.handleSendInvitations}
            >
              Send invitations
            </button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostInviteMembers.jsx